class Player {
  #id = null;
  #team = null;
  #name = '';
  #connection = null;

  constructor(connection) {
    this.#id = connection.peer;
    this.#name = connection.metadata.name;
    this.#connection = connection;
  }

  get id() {
    return this.#id;
  }

  get name() {
    return this.#name;
  }

  get team() {
    return this.#team;
  }

  set team(team) {
    this.#team = team;
  }

  send(action, data) {
    const actionCopy = action;
    const dataCopy = { ...data };

    if (action === 'message') {
      setTimeout(() => {
        this.#connection.send({ action: actionCopy, message: dataCopy });
      }, 0);
      return;
    }

    setTimeout(() => {
      this.#connection.send({ action: actionCopy, ...dataCopy });
    }, 0);
  }

  closeConnection() {
    this.#connection.close();
  }

  toJson() {
    return {
      id: this.id,
      name: this.name,
      team: this.team,
    };
  }
}

export default Player;
